var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    transform: "translate(-116 -322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M0,15,20,5,40,15V40L20,50,0,40Z",
    transform: "translate(116 317)",
    fill: "#5758a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M0,14,18,5l18,9L18,23Z",
    transform: "translate(118 342)",
    fill: "#00ffec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CTC_-_Logo_Purple_kopie",
    "data-name": "CTC - Logo Purple kopie",
    transform: "translate(-396 324.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    width: 20,
    height: 20,
    transform: "translate(522 2.2)",
    fill: "#5758a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M1016.79,443.313a.584.584,0,0,1-.08.295c-.036.046-.071.093-.11.136a2.389,2.389,0,1,1,.02-3.087c.026.031.049.06.074.093a.582.582,0,0,1,.094.32.588.588,0,0,1-1.01.411,1.1,1.1,0,0,0-.074-.094,1.22,1.22,0,1,0-.114,1.721,1.171,1.171,0,0,0,.123-.125.722.722,0,0,0,.054-.068.588.588,0,0,1,.831-.032.57.57,0,0,1,.191.432Z",
    transform: "translate(-482.83 -430.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M638.43,494.491v1.348a.092.092,0,0,1-.091.093,4.893,4.893,0,0,0-4.156,2.458v0a4.9,4.9,0,0,1-8.387.08q-.06-.109-.125-.213a4.888,4.888,0,0,0-3.989-2.323c-.025,0-.059,0-.091,0a.093.093,0,0,1-.091-.093v-1.348a.093.093,0,0,1,.093-.093h0c.049,0,.107,0,.144,0a6.39,6.39,0,0,1,3.348,1.087,6.462,6.462,0,0,1,1.874,1.937,3.245,3.245,0,0,0,.2.34,3.367,3.367,0,0,0,5.636-.036c.055-.086.108-.176.156-.269h0a6.456,6.456,0,0,1,1.893-1.97,6.389,6.389,0,0,1,3.492-1.091.09.09,0,0,1,.1.09Z",
    transform: "translate(-97.964 -484.602)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.777745317e53137065139bf10577610d.svg";
export { ForwardRef as ReactComponent };